import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const CTASection = ({ onGetStarted }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16 lg:py-20 bg-primary/5">
      <div className="max-w-4xl mx-auto text-center">
        <div className="bg-card rounded-2xl p-8 md:p-10 lg:p-12 border-2 border-primary/20 shadow-elevation-3">
          <div className="flex justify-center mb-6 md:mb-8">
            <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 rounded-2xl bg-primary/10">
              <Icon name="Sparkles" size={40} color="var(--color-primary)" className="w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12" />
            </div>
          </div>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-4 md:mb-5 lg:mb-6">
            {t('cta.title')}
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-muted-foreground mb-8 md:mb-10 lg:mb-12 max-w-2xl mx-auto leading-relaxed">
            {t('cta.description')}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-5 lg:gap-6">
            {/* NOVO: Dugme za OrizonDesk stranicu */}
            <button
              onClick={() => navigate('/orizon-desk')}
              className="w-full sm:w-auto flex items-center justify-center gap-3 px-8 md:px-10 lg:px-12 py-4 md:py-5 lg:py-6 bg-primary text-primary-foreground rounded-xl hover:scale-105 transition-all duration-250 shadow-lg font-bold min-h-[56px]"
            >
              <Icon name="Info" size={20} color="currentColor" />
              <span className="text-base md:text-lg">{t('cta.button_learn_more')}</span>
            </button>

            {/* Dugme za Kontakt */}
            <button
              onClick={() => navigate('/contact')}
              className="w-full sm:w-auto flex items-center justify-center gap-3 px-8 md:px-10 lg:px-12 py-4 md:py-5 lg:py-6 bg-card text-foreground border-2 border-border rounded-xl hover:bg-muted transition-all duration-250 shadow-elevation-1 min-h-[56px]"
              aria-label={t('cta.button_contact')}
            >
              <Icon name="Mail" size={20} color="currentColor" />
              <span className="text-base md:text-lg font-medium">{t('cta.button_contact')}</span>
            </button>
          </div>

          <div className="mt-8 md:mt-10 flex items-center justify-center gap-6 md:gap-8 lg:gap-10 flex-wrap">
            <div className="flex items-center gap-2 md:gap-3">
              <Icon name="Check" size={18} color="var(--color-success)" />
              <span className="text-sm md:text-base text-muted-foreground">
                {t('cta.feature_card')}
              </span>
            </div>
            <div className="flex items-center gap-2 md:gap-3">
              <Icon name="Check" size={18} color="var(--color-success)" />
              <span className="text-sm md:text-base text-muted-foreground">
                {t('cta.feature_setup')}
              </span>
            </div>
            <div className="flex items-center gap-2 md:gap-3">
              <Icon name="Check" size={18} color="var(--color-success)" />
              <span className="text-sm md:text-base text-muted-foreground">
                {t('cta.feature_support')}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;